
    export default {
        auth: false,
        layout: "login",
        name: "TermsAndConditionsPage",
        transitions: "page",
        data() {
            return {
                loading: false,
                header: {
                    title: "Terms and Conditions",
                    backgroundClass: "header-process",
                    // description: "Last updated September 27, 2023",
                    image: "header_process-1.png"
                },
            }
        }
    }
